import { typeData as typeDataBar } from "../../components/UI/BarChart/BarChart";
import {
  typeEmployeeTableItem,
  typeProductFullItem,
} from "./dStatisticsReducer";
import { translate } from "../../translate/translate";

const language = () => {
  return localStorage.getItem("language");
};

// Convert object data to array

export const fullStatisticObjToArray = (saleObj: any, refundObj: any) => {
  const totalArray: typeProductFullItem[] = [];

  for (let store in saleObj) {
    for (let name in saleObj[store]) {
      const item: typeProductFullItem = {
        store: store,
        name: name,
        saleTotalAmount: saleObj[store][name].totalAmount,
        saleCount: saleObj[store][name].count,
        saleAverageAmount: saleObj[store][name].averageAmount,
        refundTotalAmount: 0,
        refundCount: 0,
        refundAverageAmount: 0,
      };

      totalArray.push(item);
    }
  }

  for (let store in refundObj) {
    for (let name in refundObj[store]) {
      const productIndex = totalArray.findIndex((item) => item.name === name);
      if (productIndex >= 0) {
        totalArray[productIndex].refundTotalAmount =
          refundObj[store][name].totalAmount;
        totalArray[productIndex].refundCount = refundObj[store][name].count;
        totalArray[productIndex].refundAverageAmount =
          refundObj[store][name].averageAmount;
      }
    }
  }

  return totalArray;
};

// Average store
export const averageStore = (dataList: typeProductFullItem[]) => {
  const newList: typeProductFullItem[] = [];

  for (let index = 0; index < dataList.length; index++) {
    const existIndex = newList.findIndex(
      (item) => item.name === dataList[index].name,
    );

    if (existIndex < 0) {
      const newItem: typeProductFullItem = {
        name: dataList[index].name,
        saleTotalAmount: dataList[index].saleTotalAmount
          ? dataList[index].saleTotalAmount
          : 0,
        saleCount: dataList[index].saleCount ? dataList[index].saleCount : 0,
        saleAverageAmount: dataList[index].saleAverageAmount
          ? dataList[index].saleAverageAmount
          : 0,
        refundTotalAmount: dataList[index].refundTotalAmount
          ? dataList[index].refundTotalAmount
          : 0,
        refundCount: dataList[index].refundCount
          ? dataList[index].refundCount
          : 0,
        refundAverageAmount: dataList[index].refundAverageAmount
          ? dataList[index].refundAverageAmount
          : 0,
      };

      newList.push(newItem);
    } else {
      newList[existIndex].saleTotalAmount =
        newList[existIndex].saleTotalAmount +
        (dataList[index].saleTotalAmount ? dataList[index].saleTotalAmount : 0);
      newList[existIndex].saleCount =
        newList[existIndex].saleCount +
        (dataList[index].saleCount ? dataList[index].saleCount : 0);
      newList[existIndex].saleAverageAmount =
        (newList[existIndex].saleAverageAmount +
          (dataList[index].saleAverageAmount
            ? dataList[index].saleAverageAmount
            : 0)) /
        2;
      newList[existIndex].refundTotalAmount =
        newList[existIndex].refundTotalAmount +
        (dataList[index].refundTotalAmount
          ? dataList[index].refundTotalAmount
          : 0);
      newList[existIndex].refundCount =
        newList[existIndex].refundCount +
        (dataList[index].refundCount ? dataList[index].refundCount : 0);
      newList[existIndex].refundAverageAmount =
        newList[existIndex].refundAverageAmount +
        (dataList[index].refundAverageAmount
          ? dataList[index].refundAverageAmount
          : 0);
    }
  }

  return newList;
};

export type typeSortFields =
  | "saleTotalAmount"
  | "saleCount"
  | "saleAverage"
  | "refundAmount"
  | "refundCount"
  | "refundAverage";

// Sort statistic data
export const sortStatisticData = (
  dataList: typeProductFullItem[],
  field: typeSortFields,
  order: "asc" | "des" = "des",
) => {
  function compare(field: string, order?: number) {
    let len = arguments.length;
    if (len === 0) {
      return (a: any, b: any) => (a < b && -1) || (a > b && 1) || 0;
    }
    if (len === 1) {
      switch (typeof field) {
        case "number":
          return field < 0
            ? (a: any, b: any) => (a < b && 1) || (a > b && -1) || 0
            : (a: any, b: any) => (a < b && -1) || (a > b && 1) || 0;
        case "string":
          return (a: any, b: any) =>
            (a[field] < b[field] && -1) || (a[field] > b[field] && 1) || 0;
      }
    }
    if (len === 2 && typeof order === "number") {
      return order < 0
        ? (a: any, b: any) =>
            (a[field] < b[field] && 1) || (a[field] > b[field] && -1) || 0
        : (a: any, b: any) =>
            (a[field] < b[field] && -1) || (a[field] > b[field] && 1) || 0;
    }
    let fields: any, orders: any;
    if (typeof field === "object") {
      fields = Object.getOwnPropertyNames(field);
      orders = fields.map((key: any) => field[key]);
      len = fields.length;
    } else {
      fields = new Array(len);
      orders = new Array(len);
      for (let i = len; i--; ) {
        fields[i] = arguments[i];
        orders[i] = 1;
      }
    }
    return (a: any, b: any) => {
      for (let i = 0; i < len; i++) {
        if (a[fields[i]] < b[fields[i]]) return orders[i];
        if (a[fields[i]] > b[fields[i]]) return -orders[i];
      }
      return 0;
    };
  }

  if (order === "asc") {
    dataList.sort(compare(field));
  } else {
    dataList.sort(compare(field, -1));
  }
  return dataList;
};

// Main sale amount

export const makeSaleAmountDailyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("dailySummary" in data) {
    for (let barLabel in data.dailySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];

      for (let periodLabel in data.dailySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(
          date.toLocaleDateString(undefined, {
            day: "numeric",
            month: "numeric",
          }),
        );
        barItem.data.push(
          Number(
            data.dailySummary[barLabel][periodLabel].totalAmount.toFixed(2),
          ),
        );
      }

      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeSaleAmountWeeklyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("weeklySummary" in data) {
    for (let barLabel in data.weeklySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.weeklySummary[barLabel]) {
        const dateArray = periodLabel.split(", ");
        const year = dateArray[0].replace("y:", "");
        let month = dateArray[1].replace("m:", "");
        if (Number(month) < 10) month = "0" + month;
        const date = new Date(year + "-" + month);
        const label =
          date.toLocaleDateString(undefined, { month: "long" }) +
          " (" +
          dateArray[2].replace("w:", "") +
          ")";

        totalLabels.push(label);
        barItem.data.push(
          Number(
            data.weeklySummary[barLabel][periodLabel].totalAmount.toFixed(2),
          ),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeSaleAmountMonthlyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("monthlySummary" in data) {
    for (let barLabel in data.monthlySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.monthlySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(date.toLocaleDateString(undefined, { month: "long" }));
        barItem.data.push(
          Number(
            data.monthlySummary[barLabel][periodLabel].totalAmount.toFixed(2),
          ),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

// Main sale count

export const makeSaleCountDailyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("dailySummary" in data) {
    for (let barLabel in data.dailySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.dailySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(
          date.toLocaleDateString(undefined, {
            day: "numeric",
            month: "numeric",
          }),
        );
        barItem.data.push(
          Number(data.dailySummary[barLabel][periodLabel].count),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeSaleCountWeeklyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("weeklySummary" in data) {
    for (let barLabel in data.weeklySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.weeklySummary[barLabel]) {
        const dateArray = periodLabel.split(", ");
        const year = dateArray[0].replace("y:", "");
        let month = dateArray[1].replace("m:", "");
        if (Number(month) < 10) month = "0" + month;
        const date = new Date(year + "-" + month);
        const label =
          date.toLocaleDateString(undefined, { month: "long" }) +
          " (" +
          dateArray[2].replace("w:", "") +
          ")";

        totalLabels.push(label);
        barItem.data.push(
          Number(data.weeklySummary[barLabel][periodLabel].count),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeSaleCountMonthlyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("monthlySummary" in data) {
    for (let barLabel in data.monthlySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.monthlySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(date.toLocaleDateString(undefined, { month: "long" }));
        barItem.data.push(
          Number(data.monthlySummary[barLabel][periodLabel].count),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

// Main sale average

export const makeSaleAverageDailyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("dailySummary" in data) {
    for (let barLabel in data.dailySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.dailySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(
          date.toLocaleDateString(undefined, {
            day: "numeric",
            month: "numeric",
          }),
        );
        barItem.data.push(
          Number(
            data.dailySummary[barLabel][periodLabel].averageAmount.toFixed(2),
          ),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeSaleAverageWeeklyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("weeklySummary" in data) {
    for (let barLabel in data.weeklySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.weeklySummary[barLabel]) {
        const dateArray = periodLabel.split(", ");
        const year = dateArray[0].replace("y:", "");
        let month = dateArray[1].replace("m:", "");
        if (Number(month) < 10) month = "0" + month;
        const date = new Date(year + "-" + month);
        const label =
          date.toLocaleDateString(undefined, { month: "long" }) +
          " (" +
          dateArray[2].replace("w:", "") +
          ")";

        totalLabels.push(label);
        barItem.data.push(
          Number(
            data.weeklySummary[barLabel][periodLabel].averageAmount.toFixed(2),
          ),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeSaleAverageMonthlyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("monthlySummary" in data) {
    for (let barLabel in data.monthlySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.monthlySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(date.toLocaleDateString(undefined, { month: "long" }));
        barItem.data.push(
          Number(
            data.monthlySummary[barLabel][periodLabel].averageAmount.toFixed(2),
          ),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

// Main refund count

export const makeRefundCountDailyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("dailySummary" in data) {
    for (let barLabel in data.dailySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.dailySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(
          date.toLocaleDateString(undefined, {
            day: "numeric",
            month: "numeric",
          }),
        );
        barItem.data.push(
          Number(data.dailySummary[barLabel][periodLabel].count),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeRefundCountWeeklyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("weeklySummary" in data) {
    for (let barLabel in data.weeklySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.weeklySummary[barLabel]) {
        const dateArray = periodLabel.split(", ");
        const year = dateArray[0].replace("y:", "");
        let month = dateArray[1].replace("m:", "");
        if (Number(month) < 10) month = "0" + month;
        const date = new Date(year + "-" + month);
        const label =
          date.toLocaleDateString(undefined, { month: "long" }) +
          " (" +
          dateArray[2].replace("w:", "") +
          ")";

        totalLabels.push(label);
        barItem.data.push(
          Number(data.weeklySummary[barLabel][periodLabel].count),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeRefundCountMonthlyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("monthlySummary" in data) {
    for (let barLabel in data.monthlySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.monthlySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(date.toLocaleDateString(undefined, { month: "long" }));
        barItem.data.push(
          Number(data.monthlySummary[barLabel][periodLabel].count),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

// Main refund amount

export const makeRefundAmountDailyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("dailySummary" in data) {
    for (let barLabel in data.dailySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.dailySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(
          date.toLocaleDateString(undefined, {
            day: "numeric",
            month: "numeric",
          }),
        );
        barItem.data.push(
          Number(
            data.dailySummary[barLabel][periodLabel].totalAmount.toFixed(2),
          ),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeRefundAmountWeeklyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("weeklySummary" in data) {
    for (let barLabel in data.weeklySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.weeklySummary[barLabel]) {
        const dateArray = periodLabel.split(", ");
        const year = dateArray[0].replace("y:", "");
        let month = dateArray[1].replace("m:", "");
        if (Number(month) < 10) month = "0" + month;
        const date = new Date(year + "-" + month);
        const label =
          date.toLocaleDateString(undefined, { month: "long" }) +
          " (" +
          dateArray[2].replace("w:", "") +
          ")";

        totalLabels.push(label);
        barItem.data.push(
          Number(
            data.weeklySummary[barLabel][periodLabel].totalAmount.toFixed(2),
          ),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

export const makeRefundAmountMonthlyData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("monthlySummary" in data) {
    for (let barLabel in data.monthlySummary) {
      const barItem: { label: string; data: number[] } = {
        label: barLabel,
        data: [],
      };
      const totalLabels: string[] = [];
      for (let periodLabel in data.monthlySummary[barLabel]) {
        const date = new Date(periodLabel);
        totalLabels.push(date.toLocaleDateString(undefined, { month: "long" }));
        barItem.data.push(
          Number(
            data.monthlySummary[barLabel][periodLabel].totalAmount.toFixed(2),
          ),
        );
      }
      objData.labels = totalLabels;
      objData.datasets.push(barItem);
    }

    return objData;
  } else {
    return null;
  }
};

// Daily statistics

export const makeHourData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("hourOfDaySummary" in data) {
    const barItem: { label: string; data: number[] } = {
      label: "Sales amount",
      data: [],
    };

    for (let barLabel in data.hourOfDaySummary) {
      const label =
        Number(barLabel) > 9 ? String(barLabel) : "0" + String(barLabel);
      objData.labels.push(label);
      barItem.data.push(
        Number(data.hourOfDaySummary[barLabel].totalAmount.toFixed(2)),
      );
    }

    objData.datasets.push(barItem);

    return objData;
  } else {
    return null;
  }
};

export const makeDayData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("dayOfWeekSummary" in data) {
    const barItem: { label: string; data: number[] } = {
      label: "Sales amount",
      data: [],
    };

    for (let barLabel in data.dayOfWeekSummary) {
      objData.labels.push(translate(barLabel, language()));
      barItem.data.push(
        Number(data.dayOfWeekSummary[barLabel].totalAmount.toFixed(2)),
      );
    }

    objData.datasets.push(barItem);

    return objData;
  } else {
    return null;
  }
};

export const makePaymentMethodAmountData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("paymentMethodProportion" in data) {
    const barItem: { label: string; data: number[] } = {
      label: "Payment method sale amount",
      data: [],
    };

    for (let barLabel in data.paymentMethodProportion) {
      objData.labels.push(translate(barLabel, language()));
      barItem.data.push(
        Number(data.paymentMethodProportion[barLabel].totalAmount.toFixed(2)),
      );
    }

    objData.datasets.push(barItem);

    return objData;
  } else {
    return null;
  }
};

export const makePaymentMethodCountData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("paymentMethodProportion" in data) {
    const barItem: { label: string; data: number[] } = {
      label: "Payment method sale count",
      data: [],
    };

    for (let barLabel in data.paymentMethodProportion) {
      objData.labels.push(translate(barLabel, language()));
      barItem.data.push(Number(data.paymentMethodProportion[barLabel].count));
    }

    objData.datasets.push(barItem);

    return objData;
  } else {
    return null;
  }
};

export const makeSaleTypeAmountData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("saleTypeProportion" in data) {
    const barItem: { label: string; data: number[] } = {
      label: "Payment type sale amount",
      data: [],
    };

    for (let barLabel in data.saleTypeProportion) {
      objData.labels.push(translate(barLabel, language()));
      barItem.data.push(
        Number(data.saleTypeProportion[barLabel].totalAmount.toFixed(2)),
      );
    }

    objData.datasets.push(barItem);

    return objData;
  } else {
    return null;
  }
};

export const makeSaleTypeCountData = (data: any) => {
  const objData: typeDataBar = {
    labels: [],
    datasets: [],
  };

  if ("saleTypeProportion" in data) {
    const barItem: { label: string; data: number[] } = {
      label: "Payment type sale count",
      data: [],
    };

    for (let barLabel in data.saleTypeProportion) {
      objData.labels.push(translate(barLabel, language()));
      barItem.data.push(Number(data.saleTypeProportion[barLabel].count));
    }

    objData.datasets.push(barItem);

    return objData;
  } else {
    return null;
  }
};

export const makeEmployeeTableData = (data: any, top: boolean = false) => {
  const listData: typeEmployeeTableItem[] = [];

  if ("cashierSummary" in data) {
    let count = 0;

    for (let key in data.cashierSummary) {
      count++;
      if (!top || (top && count <= 5)) {
        listData.push({
          name: key,
          amount: Number(data.cashierSummary[key].totalAmount.toFixed(2)),
          count: Number(data.cashierSummary[key].count),
          average: Number(data.cashierSummary[key].averageAmount.toFixed(2)),
        });
      }
    }

    if (listData.length) return listData;
    else return null;
  } else {
    return null;
  }
};

export const makeProductTableData = (saleData: any, refundData: any) => {
  if ("productSummary" in saleData && "productSummary" in refundData) {
    const productStatisticArray = sortStatisticData(
      averageStore(
        fullStatisticObjToArray(
          saleData.productSummary,
          refundData.productSummary,
        ),
      ),
      "saleTotalAmount",
    );

    if (productStatisticArray.length) {
      return productStatisticArray;
    } else {
      return [];
    }
  } else {
    return [];
  }
};

export const makeFullProductTableData = (saleData: any, refundData: any) => {
  if (
    saleData &&
    "productSummary" in saleData &&
    refundData &&
    "productSummary" in refundData
  ) {
    return [];
  } else {
    return [];
  }
};
